export default "__VITE_ASSET__dbd716c6__"